import * as React from "react";
import { isVariantEnabled, Experiment } from "components/utility/experiment";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

interface QualtricsProps {
  pageName: string;
  context: ExtendedContextStore;
}

const BEX_ZONE_ID = "ZN_eEx5QN74n7JCKl7";

export const QualtricsScript = ({ context, pageName }: QualtricsProps) => {
  if (!pageName || !isVariantEnabled(context, Experiment.Flex_Blossom_Qualtrics)) {
    return null;
  }

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    require("./QualtricsSnippet").qualtricsInsert(BEX_ZONE_ID);
  }, []);

  /**
   * Qualtrics can access the pageName by using the javascript expression:
   * `document.querySelector('.qualtrics-container').dataset.pageName`
   */
  return <div data-page-name={pageName} className="is-visually-hidden qualtrics-container" />;
};
